import { render } from "./BusinessMapping.vue?vue&type=template&id=651e96e2"
import script from "./BusinessMapping.vue?vue&type=script&lang=js"
export * from "./BusinessMapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__